export function isDecimal(number) {
	return typeof number === 'number' && number % 1 !== 0;
}
